import { URL } from '../constants/api'
import request from '../utils/request'

export default {
  fetchAllServices(params) {
    var ENDPOINT = URL + 'services'
    return request(ENDPOINT, 'GET', params)
  },
}



// WEBPACK FOOTER //
// ./src/api/services.js